if($(window).width() >= 991){
  $('.grid__item .quick-add__submit').click(function(){    
    $('.upsell__product__section').appendTo('.drawer');
   $('.upsell__product__section').removeClass('active');
     var product_id= $(this).attr("data-product-id");
    var pro_id = $('.product__info-wrapper').attr("data-product-id")
     $('.drawer .upsell__product__section.product_'+product_id).each(function () {
        var upsellProduct_id = $(this).attr('data-product-id');    
        if(product_id == upsellProduct_id || pro_id == upsellProduct_id){       
            $('.upsell__product__section.product_'+product_id ).addClass('active');         
        }   
    });        
  }); 
  if($('.upsell__product__section.active').find('quick-add-top')){
    $('.upsell__product__section').removeClass('active')
  }
  if($('body').hasClass('product_details_page')){
  $('.product_details_page .product-form .product-form__submit').click(function(){    
  
   $('.product_details_page .upsell__product__section').removeClass('active');
     var product_id= $(this).attr("data-product-id");
     $('.product_details_page .drawer .upsell__product__section.product_'+product_id).each(function () {
        var upsellProduct_id = $(this).attr('data-product-id');   
         console.log(product_id)
         console.log(upsellProduct_id)
        if(product_id == upsellProduct_id){       
            $('.product_details_page .upsell__product__section.product_'+product_id ).addClass('active');
        }   
    });        
  });
  }
  $('.product_details_page .product_page.upsell__product__section').appendTo('.drawer');
  
  $('.other_page .grid__item .product-form__submit').click(function(){    
    $('.upsell__product__section').appendTo('.drawer');
   $('.upsell__product__section').removeClass('active');
     var product_id= $(this).attr("data-product-id");
    var pro_id = $('.product__info-wrapper').attr("data-product-id")
     $('.drawer .upsell__product__section.product_'+product_id).each(function () {
        var upsellProduct_id = $(this).attr('data-product-id');    
        if(product_id == upsellProduct_id || pro_id == upsellProduct_id){       
            $('.upsell__product__section.product_'+product_id ).addClass('active');         
        }   
    });        
  }); 
}
